import React, { useState } from "react";
import "./BusinessSmarter.css";

export default function BusinessSmarter() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Financial Intelligence",
      description:
        "Unlock the power of precise financial insights with our scalable Business Intelligence solutions tailored specifically for the finance sector. Let our banking intelligence solutions be your compass in navigating the complexities of financial management, guiding you toward sustainable growth and success.",
    },
    {
      id: 2,
      title: "Warehouse Intelligence",
      description:
        "Get real-time visibility into your stock levels and identify opportunities to improve your warehouse efficiency and profitability with our robust business analytics and business intelligence solutions for warehouses.",
    },
    {
      id: 3,
      title: "Retail Intelligence",
      description:
        "Optimize your retail inventory, improve merchandising strategies, and increase customer satisfaction with data-driven insights and predictions with a leading business intelligence consultancy like ours.",
    },
    {
      id: 4,
      title: "Cloud and Al Intelligence",
      description:
        "Take your Bi applications to the cloud and make more accurate and quicker predictions with automated smart data analysis solutions.",
    },
    {
      id: 5,
      title: "HR Intelligence",
      description:
        "Our comprehensive Business Intelligence solutions for HR go beyond the surface, offering invaluable insights into your workforce dynamics. Our Bl tools provide a holistic view of your HR landscape, all the way from performance metrics to training effectiveness.",
    },
    {
      id: 6,
      title: "Operational Intelligence",
      description:
        "Streamline your operations with our operational intelligence solutions, designed to enhance real-time decision-making across your production lines and operational frameworks. Our Bl solutions help you monitor performance metrics and predict potential issues before they impact efficiency.",
    },
     {
      id: 7,
      title: "Customer Intelligence",
      description:
        "Leverage our holistic and strategic BI consulting services to create marketing campaigns that can analyze in real-time which channels or content perform the best for your business.",
    },
     {
      id: 8,
      title: "Supply Chain Intelligence",
      description:
        "Optimize your supply chain with advanced analytics that provide clear visibility into every aspect of your operations. Our experts can help you anticipate demand, manage risks, and ensure a smooth flow of goods and materials, improving the overall service levels.",
    },
     {
      id: 9,
      title: "eCommerce Intelligence",
      description:
        "Leverage our holistic and strategic BI consulting services to create marketing campaigns that can analyze in real-time which channels or content perform the best for your business.",
    },
     {
      id: 10,
      title: "Production Intelligence",
      description:
        "Gain critical insights into your production efficiency, quality control, and maintenance needs. Our business intelligence consultancy experts leverage predictive analytics to forecast production outcomes, ensuring you maintain the highest standards of productivity and quality.",
    },
     {
      id: 11,
      title: "Healthcare Intelligence",
      description:
        "Optimize your supply chain with advanced analytics that provide clear visibility into every aspect of your operations. Our experts can help you anticipate demand, manage risks, and ensure a smooth flow of goods and materials, improving the overall service levels.",
    },
     {
      id: 12,
      title: "Manufacturing Intelligence",
      description:
        "Empower manufacturing  operations with advanced analytics to optimize production efficiency, quality control, and supply chain management, fostering innovation and maintaining competitive advantage.",
    },
  ];

  return (
    <div id="business-smarter" className="metaversemainclass">
      <h2 className="heading">
        An Extensive Suite of Metaverse Development Services
      </h2>
      <p className="subheading">
        The potential of metaverse exists across endless use cases and Bastionex
        is adept at meeting all of them with its services. Our pool of
        enterprise-focused metaverse development services typically includes:
      </p>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
